import { TAddress } from "@components/types"
import { getAddress } from "@core/utils"
import { addressState } from "@recoil/atoms"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"

export const AddressSmallCard = () => {
  const [address, setAddress] = useState < TAddress > ()
  const defaultaddress = useRecoilValue < TAddress > (addressState)
  const router = useRouter()

  useEffect(() => {
    setAddress(defaultaddress)
  }, [])

  const AddAddress = () => {
    router.push('/account/addresses')
  }


  return (
    <div className="flex flex-row justify-between px-2 py-1 bg-neutral-50">
      {address?.city_id == undefined ?
        <button className="py-1 px-2 border-md border border rounded-md" onClick={AddAddress}>Add Delivery Address</button>
        :
        <div className="">
          <div><span className="font-semibold">{address?.type && address?.type.length > 0 ? address?.type : "Home"}</span></div>
          <div className="flex text-md">{getAddress(address)}</div>
        </div>
      }
    </div>
  )
}

